import React from "react";
import PropTypes from "prop-types";
import SpeedDeal from "../SpeedDeal";
import { usePageContext } from "./hooks";

const SpeedDealActions = ({
  onOpenClose
}) => {
  const {
    speedDialActions,
    isSpeedDealMenuOpened,
    speedDialIconWithAction
  } = usePageContext();

  if (speedDialActions && speedDialActions.length) {
    return /*#__PURE__*/React.createElement(SpeedDeal, {
      onOpenClose: onOpenClose,
      isMenuOpened: isSpeedDealMenuOpened,
      speedDialIconWithAction: speedDialIconWithAction,
      actions: speedDialActions.map(([title, control]) => ({
        callback: control.callback,
        name: title
      }))
    });
  }

  return null;
};

SpeedDealActions.propTypes = {
  onOpenClose: PropTypes.func
};
export default SpeedDealActions;